import { Appointments } from '@interfaces/myAppointmentInterfaces';
import { EyeExamsCategories } from './EyeExamsUtils';

export const InStoreServicesAppointmentsConfig: {
    [key in EyeExamsCategories]: {
        labelKey?: string;
        appointments: Appointments[];
    };
} = {
    upcoming: {
        labelKey: 'MYAPPOINTMENTS_IN_STORE_SERVICES_UPCOMING_APPOINTMENTS_LABEL',
        appointments: [],
    },
    past: {
        labelKey: 'MYAPPOINTMENTS_IN_STORE_SERVICES_PAST_APPOINTMENTS_LABEL',
        appointments: [],
    },
};
